
import React from 'react';
import './Contact.css'
import { Container } from 'react-bootstrap';

const Contact = () => {
    return (
        <Container className='registration-form footer-design' >
            <h1 className='text-dark-50'>Contact Information</h1>
            <form>
                <p>Your Name: <input className='w-50' type="text" placeholder='your name' required /></p>

                <textarea placeholder='Write something here' name="" id="" cols="100" rows="10"></textarea>
                <br />
                <div className='contact-btn'>
                    <button> <a href="">Send to us</a> </button>
                </div>
            </form>
            <div className='contact-option'>
                <h4>Can contact either:</h4>
                <button> <a href="">GMail</a></button>
                <button>   <a href="">Facebook</a></button>
                <button>    <a href="">Twitter</a></button>
            </div>
        </Container>
    );
};

export default Contact;